// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1hhsp","requiredAsterisk":"Info_requiredAsterisk__3VqBB"};